import { Component } from 'react';
import lodash from 'lodash';
import formStyles from 'styles/forms.scss';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Link } from 'react-router';
import styles from './CreateUser.scss';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { loadGroups } from 'part11/actions/groups';
import {
    submitCreateUser,
    submitUpdateUser,
    loadUsers,
    resetUserFormFlags,
    clearUsersScene,
    loadLoginMethods,
} from 'part11/actions/users';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import {renderSelectField, renderInputField } from 'common/components/Form/Form';
import Part11Indicator from 'common/components/Part11Indicator/Part11Indicator';

export function validate (values) {
    const errors = {};
    if (!values.emailAddress) {
        errors.emailAddress = '* Required';
    }
    if (!values.displayName) {
        errors.displayName = '* Required';
    }
    if (!values.firstName) {
        errors.firstName = '* Required';
    }
    if (!values.lastName) {
        errors.lastName = '* Required';
    }
    if (!values.loginMethod) {
        errors.loginMethod = '* Required';
    }
    return errors;
}

class CreateUserForm extends Component {
    componentDidMount() {
        let values = this.getEditAbleUserValues();
        this.props.initialize(values);
    }

    getEditAbleUserValues () {
        const { isEdit, user } = this.props;
        if (isEdit) {
            return {
                id: user.id,
                sub: user.sub,
                loginMethodId: user.loginMethodId,
                firstName: user.firstName,
                lastName: user.lastName,
                emailAddress: user.emailAddress,
                displayName: user.displayName,
                ssoAttribute: user.ssoAttribute,
                groups: !lodash.isEmpty(user.groups) ? user.groups.map((g) => g.id) : []
            };
        }
    }

    render () {
        const {
            submitting,
            invalid,
            reset,
            handleSubmit,
            pristine,
            onSubmit,
            isLoading,
            groups,
            userId,
            loginMethods,
            showSsoAttribute,
            samlAttributeDisplayName,
        } = this.props;

        const submitButtonText = userId ? 'Save User' : 'Create User';
        return (
            <div className={styles.formContent}  data-cy="CreateUser">
                <form className={formStyles.form} onSubmit={handleSubmit(onSubmit)} data-cy="CreateUser-form">
                    <div className={styles.formFieldWrapper} data-cy="CreateUser-div">
                        <Part11Indicator className={styles.part11Icon} />
                        <Field
                            name="emailAddress"
                            type="email"
                            label="Email Address"
                            component={renderInputField} />
                    </div>
                    <div className={styles.formFieldWrapper} data-cy="CreateUser-divs">
                        <Part11Indicator className={styles.part11Icon} />
                        <Field
                            name="displayName"
                            type="text"
                            label="Display Name"
                            component={renderInputField} />
                    </div>
                    <div className={styles.formFieldWrapper} data-cy="CreateUser-dive">
                        <span className={styles.spacer}></span>
                        <Field
                            name="firstName"
                            type="text"
                            label="First Name"
                            component={renderInputField} />
                    </div>
                    <div className={styles.formFieldWrapper} data-cy="CreateUser-divq">
                        <span className={styles.spacer}></span>
                        <Field
                            name="lastName"
                            type="text"
                            label="Last Name"
                            component={renderInputField} />
                    </div>
                    <div className={styles.formFieldWrapper} data-cy="CreateUser-divx">
                        <Part11Indicator className={styles.part11IconGroups} />
                        <Field
                            name="groups"
                            type="text"
                            label="Groups"
                            data-test-id="group-select"
                            component={renderSelectField}
                            multiple={true} options={groups} />
                    </div>
                    { !userId &&
                        <div className={styles.formFieldWrapper} data-cy="CreateUser-divb">
                            <Part11Indicator className={styles.part11IconButton} />
                            <Field
                                name="loginMethodId"
                                type="text"
                                label="Login Method"
                                component={renderSelectField}
                                options={lodash.map(loginMethods, config => ({ ...config, displayName: `${config.name} (${config.type})` }))} />
                        </div>
                    }
                    { (showSsoAttribute) &&
                        <div className={styles.formFieldWrapper} data-cy="CreateUser-divd">
                            <span className={styles.spacer}></span>
                            <Field
                                name="ssoAttribute"
                                type="text"
                                label={samlAttributeDisplayName}
                                component={renderInputField} />
                        </div>
                    }
                    <div className={formStyles.formElement} data-cy="CreateUser-dia">
                        <button type="submit" className={formStyles.button} disabled={submitting || invalid || isLoading} data-cy="CreateUser-Saving">
                            <Part11Indicator className={styles.part11IconButton} />
                            { isLoading ? 'Saving...' : submitButtonText }
                        </button>
                    </div>
                    <div className={formStyles.formElement}>
                        <button type="button" className={formStyles.buttonReset} onClick={reset} data-cy="CreateUser-reset"
                            disabled={pristine || submitting || isLoading}>Reset values
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

const CreateUserReduxForm = reduxForm({
    form: 'createUser',
    validate
})(CreateUserForm);

export class CreateUserContainer extends Component {
    constructor (props) {
        super(props);
        this.isEdit = this.props.params.userId ? true : false;
        this.usersPath = '/admin/users';
    }

    componentDidMount () {
        const {
            loadLoginMethods,
            loadGroups,
            loadUsers,
            institutionId,
            userId,
        } = this.props;
        loadLoginMethods(institutionId);
        loadGroups(institutionId);
        if (userId) {
            loadUsers(
                institutionId,
                userId
            );
        }
    }

    componentWillUnmount () {
        this.props.resetUserFormFlags();
        this.props.clearUsersScene();
    }

    componentWillUpdate (nextProps) {
        const { shouldRedirect } = nextProps;
        if (shouldRedirect) {
            const { replace } = this.props;
            replace(this.usersPath);
        }
    }

    componentDidUpdate (previousProps) {
        const { error, addApplicationMessage } = this.props;
        if (error.isPresent) {
            const message = error.message || 'There was an error creating the user.';
            addApplicationMessage('error', message);
        }
    }

    async onSubmit (values) {
        const { me, user, institutionId, submitUpdateUser, submitCreateUser, addApplicationMessage, replace } = this.props;

        const {config} = lodash.find(this.props.loginMethods, function(method) { return method.id === values.loginMethodId; });
        if (config.isSamlAttributeEmail) {
            values.ssoAttribute = values.emailAddress;
        }

        if (this.isEdit) {
            const { payload } = await submitUpdateUser(institutionId, values);
            if (lodash.isEmpty(payload.error)) {
                const { emailAddress, sub } = values;
                if (emailAddress !== user.emailAddress) {
                    addApplicationMessage(
                        'success',
                        `Email successfully changed! A confirmation email has been sent to ${emailAddress}.`
                    );

                    if (sub === me.sub) {
                        replace('/logout');
                    }
                }
            }
        } else {
            submitCreateUser(institutionId, values);
        }
    }

    render() {
        const { isLoading, groups, user, userId, loginMethods, showSsoAttribute, samlAttributeDisplayName } = this.props;
        if (this.isEdit && !user) {
            return null;
        }
        return (
            <div className={styles.page} data-cy="CreateUser-onSubmit">
                <div className={styles.pageHeader}>
                    <Link className={styles.back} to={this.usersPath}>
                        { '< back to users' }
                    </Link>
                    <span className={styles.heading} data-cy="CreateUser-action">
                        {userId ? 'Edit User' : 'Create User'}
                    </span>
                </div>
                <div className={styles.container} data-cy="CreateUser-CreateUserReduxForm">
                    <CreateUserReduxForm
                        groups={groups}
                        userId={userId}
                        user={user}
                        isEdit={this.isEdit}
                        isLoading={isLoading}
                        loginMethods={loginMethods}
                        onSubmit={this.onSubmit.bind(this)}
                        showSsoAttribute={showSsoAttribute}
                        samlAttributeDisplayName={samlAttributeDisplayName}
                    />
                </div>
            </div>
        );
    }
}

export default connect(
    (state, props) => {
        const institutionId = props.params.id || state.me.institution.id;
        const userId = props.params.userId || null;
        const user = lodash.get(state, `users.${props.params.userId}`);
        const isLoading = lodash.get(state, 'createUser.isLoading', false);
        const shouldRedirect = lodash.get(state, 'createUser.shouldRedirect', false);
        const error = lodash.get(state, 'createUser.error', { isPresent: false, message: null });
        const groups = lodash.get(state, 'groups', []);
        const selector = formValueSelector('createUser');
        const loginMethodId = selector(state, 'loginMethodId');
        const loginMethods = lodash.get(state, 'loginMethods');
        const me = lodash.get(state, 'me');

        let showSsoAttribute = false;
        let samlAttributeDisplayName = null;
        if (loginMethodId && loginMethods) {
            const {config} = lodash.find(loginMethods, function(method) { return method.id === loginMethodId; });
            // Show the sso attribute if we need to specify one but the attribute will not be equal to the user's email address
            showSsoAttribute = !config.isSamlAttributeEmail && !lodash.isNil(config.userAttribute);
            samlAttributeDisplayName = config.samlAttributeDisplayName;
        }

        return {
            me,
            groups,
            error,
            shouldRedirect,
            isLoading,
            user,
            institutionId,
            userId,
            loginMethods,
            showSsoAttribute,
            samlAttributeDisplayName,
        };
    }, {
        loadGroups,
        loadUsers,
        loadLoginMethods,
        submitCreateUser,
        submitUpdateUser,
        addApplicationMessage,
        clearUsersScene,
        resetUserFormFlags,
        replace,
    })(CreateUserContainer);
